import React, { useEffect, useState, useRef } from "react";
import { createPortal } from "react-dom";
import "./index.less";
import Logo from "@/assets/images/zdlogo.svg";
import SetImg from "@/assets/images/set.svg";
import WelcomeLogo from "@/assets/images/welcomeLogo.png";
import NewWelcomeLogo from "@/assets/images/newWelcome.svg";
import AudioIcon from "@/assets/images/audioIcon.svg";
import AudioLoadingIcon from "@/assets/images/audioLoadingIcon.svg";
import Ykzs from "@/assets/images/ykzs.png";
import Zwxz from "@/assets/images/zwxz.png";
import Zxb from "@/assets/images/zxb.png";
import Yxy from "@/assets/images/yxy.png";
import Lx from "@/assets/images/lx.png";
import Xzzd from "@/assets/images/xzzd.png";
import Etlink from "@/assets/images/etlink.png";
import FxwxSmall from "@/assets/images/fxwxsmall.png";
import PlayIcon from "@/assets/images/play.svg";
import DisPlayIcon from "@/assets/images/display.svg";
import {
  ChatBox,
  ChatThinkActionButton,
  ChatScrollWrapper,
  ChatActionButton,
  ChatBoxItem,
  ChatBubblePromptsCard,
} from "@sui/chat-ui";
import {
  Select,
  Button,
  Row,
  Col,
  Typography,
  Tooltip,
  Modal,
  Drawer,
  Space,
  Dropdown,
  Tag,
  message,
} from "antd";
import {
  CheckOutlined,
  CloseOutlined,
  CloudUploadOutlined,
  DownOutlined,
  ReloadOutlined,
} from "@ant-design/icons";
import axios from "axios";
import { API, getAudio2Text, getSkillList } from "@/api";
import { getChatUrl, isMobile } from "@/utils/public";
import useBaseRequest from "@/hooks/useBaseRequest";
import { useArraySlicer } from "@/hooks/zdindex";
import Fj from "@/assets/images/fj.svg";
import { Attachments } from "@ant-design/x";
import ZdKnowledge from "../../../pages/chat/zsk";
import EnterImg from "@/assets/images/enter.svg";
import BackOld from "@/assets/images/backold.svg";
import RecordRTC from "recordrtc";
import * as dd from "dingtalk-jsapi";

function ZdHome() {
  const [newData, setNewData] = useState([]);
  const [newInit, setNewInit] = useState(false);
  const [initObj, setInitObj] = useState({});
  const [newZntData, setNewZntData] = useState([]);
  const [deepthink, setDeepthink] = useState(false);
  const [skillList, setSkillList] = useState([]);
  const [hotList, setHotList] = useState([]);
  const [isPlaying, setIsPlaying] = useState(false);
  const [skillsName, setSkillName] = useState("");
  const [newInputId, setNewInputId] = useState("");
  const [zdzxJump, setZdzxJump] = useState(false);
  const [newSoltInput, setNewSoltInput] = useState(undefined);
  const [newRefresh, setNewRefresh] = useState("");
  const [zdKnowledgeOpen, setZdKnowledgeOpen] = useState(false);
  const [zdKnowledgeName, setZdKnowledgeName] = useState("");
  const [selectedValue, setSelectedValue] = useState({});
  const [chooseZskType, setChooseZskType] = useState("");
  const zdKnowledgeRef = useRef();
  const [moreModel, setMoreModel] = useState([]);
  const [selectedModelValue, setSelectedModelValue] = useState({});
  const [qzzkType, setQzzkType] = useState("zsk");
  const [otherType, setOtherType] = useState("");
  const [zdPlaceholder, setZdPlaceholder] = useState(
    "晓浙，提供学校资讯、规范性文件、通知公告、办事指南和通讯录的精确检索与智能问答（Shift+Enter换行）",
  );
  const [changeContent, setChangeContent] = useState("");
  const [categoryDataList, setCategoryDataList] = useState([]);
  const [zxLoaidng,setZxLoading] = useState(true);

  const hotListRef = useRef();

  const isMob = isMobile();

  //录音相关
  const [recording, setRecording] = useState(false);
  const [recordMode, setRecordMode] = useState(null);
  const recorderRef = useRef(null);
  const audioRef = useRef(null);

  useEffect(() => {
    axios.all([getInitData(), getZntDatas()]).then(
      axios.spread((res, res1, res2) => {
        console.log("宁波理工===", res1);
        const data = res?.data?.result?.data;
        const data1 = res1?.data?.result?.data || [];

        const arr = [];
        const arr1 = [];
        const arr2 = [];
        data.hotqas?.map((item) => {
          arr.push({
            key: item.id,
            description: item.name,
          });
        });

        axios.all([getHots()]).then(
          axios.spread((res2) => {
            const data2 = res2?.data || [];
            data2.map((item, index) => {
              arr2.push({
                id: item.sys_id,
                description: index + 1 + "、" + item.sys_title,
                url: item.sys_link.replace("https", "http"),
              });

              setHotList(arr2.slice(0, 8));
              hotListRef.current = arr2;
              setZxLoading(false);
            });
          }),
        );

        data1.map((item) => {
          if (item.id * 1 === 4 || item.id * 1 === 5) {
            arr1.push({
              name: item.name,
              description: item.summary,
              icon: item.icon,
              id: item.id,
            });
          }
        });

        const models = data?.llmlist || [];
        setMoreModel([
          ...models.map((item) => {
            return {
              key: item.id,
              label: item.name,
            };
          }),
        ]);
        setSelectedModelValue({
          key: models?.[0] ? models?.[0].id : "",
          // key: "",
          label: models?.[0] ? models?.[0].name : "",
          // label: "",
        });
        setNewInit(true);
        setNewData(arr);
        setInitObj(data);
        setNewZntData(arr1);

        runGetAllSkill(data?.id);
        setA(Math.random());
        setNewRefresh(Math.random());
      }),
    );
  }, []);

  const getInitData = () => {
    return axios.get(API.serInit);
  };

  const getZntDatas = () => {
    return axios.get(API.categaryList);
  };

  const getHots = () => {
    return axios.get(
      "https://service.zju.edu.cn/_web/customized/queryHotArticles.jsp?_p=YXM9MSZwPTEmbT1OJg__",
    );
  };

  //获取所有的任务列表
  const {
    data: getAllSkillData,
    loading: getAllSkillLoading,
    runAsync: runGetAllSkill,
  } = useBaseRequest((params) => getSkillList(params), {
    manual: true,
    onSuccess: (res) => {
      setSkillList(res?.data);
    },
  });

  const promptsItems = hotList?.length
    ? hotList.map((subject) => {
        return {
          key: subject.id,
          description: subject.description,
          url: subject.url,
        };
      })
    : undefined;

  const nextHots = useArraySlicer(hotListRef.current, 8);
  const onReloadHots = () => {
    setHotList(nextHots());
  };

  useEffect(() => {
    if (initObj?.userId && initObj?.forcelogin === 0) {
      // window.location.href = initObj?.loginUrl;
      window.open("/#/zdChat", "_self");
    } else {
    }
  }, [initObj?.id]);

  const loginFun = (val) => {
    if (!initObj?.userId && initObj?.forcelogin === 1) {
      if (process.env.NODE_ENV === "development") {
        return;
      }
      window.location.href = initObj?.loginUrl;
    } else {
      console.log(newSoltInput);
      if (zdzxJump) {
        window.open(`http://10.204.19.136/#?searchType=zh&keyword=${val}`);
      } else {
        if (fileList && fileList.length) {
          window.sessionStorage.setItem("files", JSON.stringify(fileList));
        }
        window.sessionStorage.setItem(
          "question",
          JSON.stringify(encodeURIComponent(val)),
        );
        if (newInputId) {
          window.sessionStorage.setItem("skillId", JSON.stringify(newInputId));
        }
        if (skillsName) {
          window.sessionStorage.setItem(
            "skillName",
            JSON.stringify(skillsName),
          );
        }
        if (newSoltInput) {
          window.sessionStorage.setItem("forms", JSON.stringify(newSoltInput));
        }
        if (selectedValue) {
          window.sessionStorage.setItem(
            "selectedValue",
            JSON.stringify(selectedValue),
          );
        }

        if (deepthink === false || deepthink === true) {
          window.sessionStorage.setItem(
            "deepthink",
            JSON.stringify(deepthink),
            // selectedModelValue?.key === ""
            //   ? JSON.stringify(deepthink)
            //   : JSON.stringify(true),
          );
        }

        if (selectedModelValue) {
          window.sessionStorage.setItem(
            "selectedModelValue",
            JSON.stringify(selectedModelValue),
          );
        }

        if (otherType) {
          window.sessionStorage.setItem("otherType", JSON.stringify(otherType));
        }
        window.sessionStorage.setItem(
          "newInputSubmit",
          JSON.stringify(newInputId ? true : false),
        );
        window.open(`/#/zdChat`, "_self");
      }
    }
  };

  // 检查钉钉 JSAPI 是否可用
  const checkDingTalkAPI = () => {
    if (typeof dd === "undefined" || !dd.device || !dd.device.audio) {
      throw new Error("钉钉 JSAPI 未加载或不可用，请确保在钉钉 App 内打开");
    }
  };

  //钉钉录音
  //开始录音
  const startDingTalkRecording = () => {
    return new Promise((resolve, reject) => {
      // 设置超时，防止一直等待
      const timer = setTimeout(() => {
        reject(new Error("钉钉录音启动超时，请检查权限或网络"));
      }, 5000);

      try {
        checkDingTalkAPI();

        const onSuccess = () => {
          clearTimeout(timer);
          console.log("钉钉开始录音");
          resolve();
        };

        const onFail = (err) => {
          clearTimeout(timer);
          console.error("钉钉录音失败", err);
          reject(new Error("钉钉录音失败: " + JSON.stringify(err)));
        };

        // 确保钉钉 JSAPI 已初始化
        if (dd && typeof dd.ready === "function") {
          dd.ready(() => {
            dd.device.audio.startRecord({
              success: onSuccess,
              fail: onFail,
            });
          });
          // 捕获钉钉鉴权错误
          if (typeof dd.error === "function") {
            dd.error((err) => {
              clearTimeout(timer);
              console.error("钉钉鉴权失败", err);
              // 鉴权失败不一定影响录音（取决于API），但最好记录
            });
          }
        } else {
          // 如果 dd.ready 不存在，直接调用（钉钉 App 内可能已自动初始化）
          dd.device.audio.startRecord({
            success: onSuccess,
            fail: onFail,
          });
        }
      } catch (error) {
        clearTimeout(timer);
        reject(error);
      }
    });
  };
  //结束录音
  const stopDingTalkRecording = async () => {
    return new Promise((resolve, reject) => {
      try {
        checkDingTalkAPI();
        dd.device.audio.stopRecord({
          success: (res) => {
            //mediaId 是钉钉音频文件标识
            resolve(res.mediaId);
          },
          fail: (err) => {
            reject(new Error("钉钉停止录音失败: " + JSON.stringify(err)));
          },
        });
      } catch (error) {
        reject(error);
      }
    });
  };
  //下载钉钉音频
  const downloadDingTalkAudio = async (mediaId) => {
    return new Promise((resolve, reject) => {
      try {
        checkDingTalkAPI();
        dd.device.audio.download({
          mediaId: mediaId,
          onSuccess: function (res) {
            resolve(res.localAudioId);
          },
          onFail: function (err) {
            reject(new Error("钉钉下载音频失败: " + JSON.stringify(err)));
          },
        });
      } catch (error) {
        reject(error);
      }
    });
  };

  //语音播放
  // 播放/暂停
  const togglePlayPause = () => {
    if (audioRef.current) {
      if (isPlaying) {
        console.log("停止");
        audioRef.current.pause();
      } else {
        console.log("播放");
        audioRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  // 基础状态
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  const [scrollTop, setScrollTop] = useState(0);
  // 新增：控制hover状态
  const [isListHover, setIsListHover] = useState(false);
  const [isBott, setIsAtBottom] = useState(false);
  const [fixedHeight, setFixedHeight] = useState(false);
  const [a, setA] = useState("");
  const [chooseZsk, setChooseZsk] = useState(false);
  // 新增：底部状态锁定，避免反复刷新

  // Ref定义
  const scrollContainerRef = useRef(null);

  const checkScreenSize = () => {
    setIsSmallScreen(window.innerHeight < 975);
  };

  // 监听屏幕尺寸变化
  useEffect(() => {
    // 初始检查
    checkScreenSize();

    // 监听resize事件
    window.addEventListener("resize", checkScreenSize);

    return () => {
      window.removeEventListener("resize", checkScreenSize);
    };
  }, [a]);

  const [bigScreen, setIsBigScreen] = useState(false);

  const checkScreenSizeBig = () => {
    setIsBigScreen(window.innerHeight >= 975);
  };

  useEffect(() => {
    checkScreenSizeBig();
    // 监听resize事件
    window.addEventListener("resize", checkScreenSizeBig);

    return () => {
      window.removeEventListener("resize", checkScreenSizeBig);
    };
  }, [a]);

  const handleScroll2 = () => {
    const senderHeight = document
      .getElementsByClassName("sui-chatui-box-senderbox")[0]
      ?.getBoundingClientRect();
    if (!bigScreen || !scrollContainerRef.current) return;
    // console.log(senderHeight, scrollContainerRef.current, "这个高度是多少");
    if (senderHeight.top < 120) {
      document.getElementsByClassName(
        "sui-chatui-box-senderbox",
      )[0].style.position = "fixed";
      document.getElementsByClassName("sui-chatui-box-senderbox")[0].style.top =
        "68px";
      document.getElementsByClassName(
        "sui-chatui-box-senderbox",
      )[0].style.width = "100%";
      document.getElementsByClassName(
        "sui-chatui-box-senderbox",
      )[0].style.zIndex = "111";
      if (isMob) {
        document.getElementsByClassName(
          "sui-chatui-box-senderbox",
        )[0].style.paddingRight = "unset";
      } else {
        document.getElementsByClassName(
          "sui-chatui-box-senderbox",
        )[0].style.paddingRight = "11px";
      }
    }

    console.log(senderHeight, scrollContainerRef, "这是多少高度");

    if (
      scrollContainerRef.current.scrollTop === 0 ||
      scrollContainerRef.current.scrollTop <= 92
    ) {
      document.getElementsByClassName(
        "sui-chatui-box-senderbox",
      )[0].style.position = "unset";
      document.getElementsByClassName("sui-chatui-box-senderbox")[0].style.top =
        "unset";
      document.getElementsByClassName(
        "sui-chatui-box-senderbox",
      )[0].style.width = "unset";
      document.getElementsByClassName(
        "sui-chatui-box-senderbox",
      )[0].style.zIndex = "unset";
      document.getElementsByClassName(
        "sui-chatui-box-senderbox",
      )[0].style.paddingRight = "unset";
    }
  };

  useEffect(() => {
    if (!scrollContainerRef.current) return;
    const container = scrollContainerRef.current;

    container.addEventListener("scroll", handleScroll2);
    return () => container.removeEventListener("scroll", handleScroll2);
  }, [bigScreen, a]);

  const handleScroll = () => {
    setScrollTop(scrollContainerRef?.current.scrollTop);

    // 判断是否滚动到底部
    const isAtBottom =
      scrollContainerRef?.current.scrollHeight -
        scrollContainerRef?.current.scrollTop <=
      scrollContainerRef?.current.clientHeight + 1;
    const threshold = 10;

    const isNearBottom =
      scrollContainerRef?.current.scrollHeight -
        scrollContainerRef?.current.scrollTop <=
      scrollContainerRef?.current.clientHeight + threshold;
    const scollHeight = document
      .getElementsByClassName("cards")[0]
      .getBoundingClientRect();

    const senderHeight = document
      .getElementsByClassName("sui-chatui-box-senderbox")[0]
      ?.getBoundingClientRect();
    console.log(senderHeight, "这是多少");
    if (window.innerHeight - scollHeight.top > 350) {
      // setIsAtBottom(true);
      setFixedHeight(true);
    } else {
      // setFixedHeight(false);
      // setIsAtBottom(false);
    }

    if (senderHeight.top < 120) {
      document.getElementsByClassName(
        "sui-chatui-box-senderbox",
      )[0].style.position = "fixed";
      document.getElementsByClassName("sui-chatui-box-senderbox")[0].style.top =
        "68px";
      document.getElementsByClassName(
        "sui-chatui-box-senderbox",
      )[0].style.width = "100%";
      document.getElementsByClassName(
        "sui-chatui-box-senderbox",
      )[0].style.zIndex = "111";
      if (isMob) {
        document.getElementsByClassName(
          "sui-chatui-box-senderbox",
        )[0].style.paddingRight = "unset";
      } else {
        document.getElementsByClassName(
          "sui-chatui-box-senderbox",
        )[0].style.paddingRight = "11px";
      }
    }

    if (
      scrollContainerRef.current.scrollTop === 0 ||
      scrollContainerRef.current.scrollTop <= 90
    ) {
      document.getElementsByClassName(
        "sui-chatui-box-senderbox",
      )[0].style.position = "unset";
      document.getElementsByClassName("sui-chatui-box-senderbox")[0].style.top =
        "unset";
      document.getElementsByClassName(
        "sui-chatui-box-senderbox",
      )[0].style.width = "unset";
      document.getElementsByClassName(
        "sui-chatui-box-senderbox",
      )[0].style.zIndex = "unset";
      document.getElementsByClassName(
        "sui-chatui-box-senderbox",
      )[0].style.paddingRight = "unset";
      document.getElementsByClassName(
        "sui-chatui-box-senderbox",
      )[0].style.transform = "transform 0.3s ease";
    }

    // if (isNearBottom) {
    //   // console.log("已滚动到底部");
    //   setIsAtBottom(true);
    //   // container.removeEventListener("scroll", handleScroll)
    // } else {
    //   setIsAtBottom(false);
    // }
  };
  // 2. 监听滚动容器滚动
  useEffect(() => {
    if (!isSmallScreen || !scrollContainerRef.current) return;
    const container = scrollContainerRef.current;

    container.addEventListener("scroll", handleScroll);
    return () => container.removeEventListener("scroll", handleScroll);
  }, [isSmallScreen, a]);

  // 3. 计算旋转角度（hover时强制为0）
  const getRotateAngle = () => {
    // hover状态下直接回正，否则按滚动计算
    if (isListHover || !isSmallScreen) return 0;

    const container = scrollContainerRef.current;
    if (!container) return 0;

    const maxScroll = container.scrollHeight - container.clientHeight;

    const angle = 30 - (scrollTop / (maxScroll || 1)) * 30;
    return Math.max(angle, 0);
  };

  //上传图片相关
  const [fileOpen, setFileOpen] = useState(false);
  const attachmentsRef = useRef(null);
  const [fileList, setFileList] = useState([]);
  const picRef = useRef();
  const fileRef = useRef();
  const fileAndImgRef = useRef();

  //文件和图片上传相关
  const header = fileOpen ? (
    <div
      style={{
        minHeight: "120px",
        background: "#fff",
        borderRadius: "12px",
        position: "relative",
      }}
      className="headerFile"
    >
      <div
        style={{
          textAlign: "right",
          position: "absolute",
          right: "10px",
          top: "10px",
          zIndex: "99",
        }}
      >
        <CloseOutlined
          style={{
            cursor: "pointer",
          }}
          onClick={() => {
            setFileOpen(false);
            setFileList([]);
          }}
        />
      </div>
      <Attachments
        overflow="scrollX"
        ref={attachmentsRef}
        items={fileList}
        multiple={true}
        accept={
          initObj?.enabledfileupload * 1 === 1 &&
          initObj?.enabledimgupload * 1 === 1
            ? ".jpg,.jpeg,.png,.csv,.md,application/pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt"
            : initObj?.enabledimgupload * 1 === 1
            ? ".jpg,.jpeg,.png,"
            : initObj?.enabledfileupload * 1 === 1
            ? ".csv,.md,application/pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt"
            : ""
        }
        maxCount={
          initObj?.enabledfileupload * 1 === 1 &&
          initObj?.enabledimgupload * 1 === 1
            ? initObj?.fileuploadcount * 1 + initObj?.imguploadcount * 1
            : initObj?.enabledfileupload * 1 === 1
            ? initObj?.fileuploadcount * 1
            : initObj?.enabledimgupload * 1 === 1
            ? initObj?.imguploadcount * 1
            : undefined
        }
        beforeUpload={(file) => {
          let uploadTypes = [];
          if (
            initObj?.enabledfileupload * 1 === 1 &&
            initObj?.enabledimgupload * 1 === 1
          ) {
            uploadTypes = [
              "image/jpeg",
              "image/png",
              "image/gif",
              "image/bmp",
              "application/pdf",
              "application/msword", // .doc
              "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
              "application/vnd.ms-powerpoint", // .ppt
              "application/vnd.ms-excel", // .xls
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
              "application/vnd.openxmlformats-officedocument.presentationml.presentation", // .pptx
              "text/markdown", // .md
              "text/csv", // .csv
              "text/plain", // 兼容扩展名检查
            ];
          } else {
            if (initObj?.enabledfileupload * 1 === 1) {
              uploadTypes = uploadTypes = [
                "application/pdf",
                "application/msword", // .doc
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
                "application/vnd.ms-powerpoint", // .ppt
                "application/vnd.ms-excel", // .xls
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
                "application/vnd.openxmlformats-officedocument.presentationml.presentation", // .pptx
                "text/markdown", // .md
                "text/csv", // .csv
                "text/plain", // 兼容扩展名检查
              ];
            }

            if (initObj?.enabledimgupload * 1 === 1) {
              uploadTypes = [
                "image/jpeg",
                "image/png",
                "image/gif",
                "image/bmp",
              ];
            }
          }

          const newCount = fileList.length + 1; // 当前已选 + 待上传
          if (
            initObj?.enabledfileupload * 1 === 1 &&
            initObj?.enabledimgupload * 1 === 1
          ) {
            const imageCount = fileList.filter(
              (file) => file.type === "image",
            ).length;
            const fileCount = fileList.filter(
              (file) => file.type === "document",
            ).length;
            if (imageCount >= initObj?.imguploadcount * 1) {
              message.warning(
                `最多只能上传${initObj?.imguploadcount * 1}张图片`,
              );
              return false;
            }

            if (fileCount >= initObj?.fileuploadcount * 1) {
              message.warning(
                `最多只能上传${initObj?.fileuploadcount * 1}个附件`,
              );
              return false;
            }

            if (
              newCount >
              initObj?.fileuploadcount * 1 + initObj?.imguploadcount * 1
            ) {
              message.warning(
                `最多只能上传${
                  initObj?.fileuploadcount * 1 + initObj?.imguploadcount * 1
                }个附件`,
              );
              return false;
            }
          } else {
            if (initObj?.enabledfileupload * 1 === 1) {
              if (newCount > initObj?.fileuploadcount * 1) {
                message.warning(
                  `最多只能上传${initObj?.fileuploadcount * 1}个附件`,
                );
                return false;
              }
            }

            if (initObj?.enabledimgupload * 1 === 1) {
              if (newCount > initObj?.imguploadcount * 1) {
                message.warning(
                  `最多只能上传${initObj?.imguploadcount * 1}张图片`,
                );
                return false;
              }
            }
          }

          const isAllowed =
            uploadTypes.includes(file.type) ||
            file.name.includes("md") ||
            file.name.includes("MD");

          // 获取文件扩展名
          const fileName = file.name;
          const extension = fileName
            .substring(fileName.lastIndexOf(".") + 1)
            .toLowerCase();

          // 设置不同文件类型的大小限制
          const isImage = ["jpg", "jpeg", "png"].includes(extension);
          const maxSize = isImage ? 30 * 1024 * 1024 : 100 * 1024 * 1024; // 图片30MB，其他文件100MB

          if (file.size > maxSize) {
            message.error(
              `${isImage ? "图片" : "文件"}大小不能超过${
                isImage ? "30MB" : "100MB"
              }`,
            );
            return Upload.LIST_IGNORE;
          }

          if (!isAllowed) {
            message.error(
              "仅支持图片、文档、Markdown (.md) 和 CSV (.csv) 文件",
            );
            return Upload.LIST_IGNORE; // 阻止添加到文件列表
          }

          return true;
        }}
        onRemove={(file) => {
          const newFileList = fileList.filter((item) => item.uid !== file.uid);
          setFileList(fileList && fileList.length ? newFileList : []);
        }}
        customRequest={(val) => {
          const { file } = val;
          const formData = new FormData();
          formData.append("files", file);
          axios
            .post(API.uploadDocs, formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then((res) => {
              const data = res?.data?.result?.data || [];
              const arr = [];
              data.map((item) => {
                arr.push({
                  uid: item.uuid,
                  name: item.filename,
                  status: "done",
                  url:
                    window.location.origin +
                    API.askDownLoadDocs +
                    `/${item.uuid}.${item?.filename?.split(".")[1]}`,
                  type: item.type,
                  uuid: item.uuid,
                  size: file.size,
                });
              });
              setFileList([...fileList, ...arr]);
            });
        }}
        placeholder={(type) =>
          type === "drop"
            ? {
                title: "Drop file here",
              }
            : {
                icon: <CloudUploadOutlined />,
                title: "上传文件",
                description: "单击或拖动文件到此区域进行上传",
              }
        }
      ></Attachments>
    </div>
  ) : undefined;

  //录音相关
  //开始录音(统一入口)

  //判断是否是钉钉环境
  function isDDing() {
    var userAgent = navigator.userAgent;
    const isDingTalk = userAgent.indexOf("DingTalk") > -1;
    return isDingTalk;
  }
  const startAudio = async () => {
    if (recording) {
      return;
    }
    const isFullTime = window.isFullTime;
    const isDDing = false;
    console.log(
      "开始录音, 环境:",
      isDDing ? "钉钉" : "浏览器",
      "模式:",
      !isFullTime ? "实时" : "非实时",
    );

    try {
      if (isDDing) {
        if (!isFullTime) {
          await startRecording();
        } else {
          await startDingTalkRecording();
          setRecordMode("dingtalk-once");
          setRecording(true);
        }
      } else {
        if (!isFullTime) {
          await startRecording();
        } else {
          console.log("开始录音(非实时)");
          const stream = await navigator.mediaDevices.getUserMedia({
            audio: true,
            video: false,
          });
          const recorder = new RecordRTC.RecordRTCPromisesHandler(stream, {
            type: "audio",
            mimeType: "audio/webm",
            recorderType: RecordRTC.StereoAudioRecorder,
            desiredSampRate: 16000,
            numberOfAudioChannels: 1,
            disableLogs: false,
          });
          await recorder.startRecording();
          recorderRef.current = recorder;
          setRecordMode("browser-once");
          setRecording(true);
        }
      }
    } catch (e) {
      console.error("开始录音失败", e);
      message.error("开始录音失败: " + (e.message || "请检查麦克风权限"));
      setRecording(false);
      setRecordMode(null);
    }
  };
  console.log("recording==", recording);

  //结束录音(统一入口)
  async function localAudioIdToBlob(localAudioId) {
    try {
      // 尝试使用 XHR 获取 Blob，兼容性更好
      return await new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open("GET", localAudioId, true);
        xhr.responseType = "blob";
        xhr.onload = function () {
          if (this.status === 200 || this.status === 0) {
            resolve(this.response);
          } else {
            reject(new Error("XHR failed status: " + this.status));
          }
        };
        xhr.onerror = function () {
          reject(new Error("XHR failed"));
        };
        xhr.send();
      });
    } catch (e) {
      console.warn("XHR failed, trying fetch", e);
      const res = await fetch(localAudioId);
      return await res.blob();
    }
  }

  const cancelRecording = async () => {
    console.log("取消录音");
    const isDDing = false;
    if (!recording) return;
    try {
      if (recordMode === "dingtalk-once" || isDDing) {
        await stopDingTalkRecording();
      } else if (recordMode === "browser-once" || recorderRef.current) {
        await recorderRef.current.stopRecording();
      }
    } catch (e) {
      console.error("取消录音失败", e);
    }
    recorderRef.current = null;
    setRecording(false);
    setRecordMode(null);
  };

  // 兼容钉钉的 Toast
  const showToast = (content, type = "info") => {
    if (
      isDDing() &&
      dd &&
      dd.device &&
      dd.device.notification &&
      dd.device.notification.toast
    ) {
      let icon = "success";
      if (type === "error") icon = "error";
      if (type === "warning") icon = "";
      dd.device.notification.toast({
        icon: icon,
        text: content,
        duration: 2.1,
        delay: 0,
        onSuccess: function (result) {},
        onFail: function (err) {},
      });
    } else {
      message[type](content);
    }
  };

  // 兼容钉钉的 Loading
  const showLoading = (content) => {
    if (
      isDDing() &&
      dd &&
      dd.device &&
      dd.device.notification &&
      dd.device.notification.showPreloader
    ) {
      dd.device.notification.showPreloader({
        text: content,
        showIcon: true,
        onSuccess: function (result) {},
        onFail: function (err) {},
      });
      return () =>
        dd.device.notification.hidePreloader({
          onSuccess: function (result) {},
          onFail: function (err) {},
        });
    } else {
      return message.loading(content, 0);
    }
  };

  const stopRecording = () => {
    if (recorderRef.current && audioRef.current) {
      const recorder = recorderRef.current;
      const ws = audioRef.current;
      console.log(audioRef, recorder, "这是啥");
      recorder.stopRecording();
      setTimeout(() => {
        // 检查 WebSocket 状态再操作
        if (ws.readyState === WebSocket.OPEN) {
          try {
            // 发送明确的结束指令到服务器（如 "{type: 'stop'}"）
            if (window.isAly) {
              ws.send(new Uint8Array(0));
            } else {
              ws.send("");
            }

            // 非实时模式下，在结束时将最终结果填入输入框
            if (window.isFullTime) {
              console.log(
                "非实时模式，填入最终识别结果:",
                latestASRResult.current,
              );
              // chatBoxRef.current?.senderBox.setContent(latestASRResult.current);
              const text = latestASRResult.current;
              if (text) {
                StartChat(text);
              }
            }

            ws.close(1000, "这是关闭");
            console.log("WebSocket 关闭成功");
          } catch (error) {
            console.error("关闭 WebSocket 失败:", error);
          }
        } else {
        }
        // 清理引用
        audioRef.current = null;
        recorderRef.current = null;
        setRecording(false);
      }, 1000);

      // recorderRef.current.stopRecording(() => {
      //     setTimeout(() => {
      //         audioRef.current?.send('');
      //         audioRef.current?.close();
      //     }, 1000)

      //     setRecording(false);
      // });
    }
  };

  //语音转文字
  const { data: audio2TextData, runAsync: runGetAudio2Text } = useBaseRequest(
    (zntId, file) => getAudio2Text(zntId, file),
    {
      manual: true,
      onSuccess: (res) => {
        console.log(res, "audio2text 接口返回");
      },
    },
  );

  const stopAudio = async () => {
    const isFullTime = window.isFullTime;
    console.log("结束录音, 模式:", isFullTime ? "实时" : "非实时");
    const isDDing = false;
    if (!isFullTime) {
      stopRecording();
    } else {
      console.log("结束录音(非实时)");
      if (!recording) {
        return;
      }
      try {
        let blob = null;
        if (recordMode === "dingtalk-once" || isDDing) {
          const mediaId = await stopDingTalkRecording();
          try {
            const localAudioId = await downloadDingTalkAudio(mediaId);
            blob = await localAudioIdToBlob(localAudioId);
          } catch (blobErr) {
            console.warn("获取音频Blob失败，尝试translateVoice", blobErr);
            if (
              dd &&
              dd.device &&
              dd.device.audio &&
              dd.device.audio.translateVoice
            ) {
              const hideLoading = showLoading("音频获取失败，尝试云端转译...");
              dd.device.audio.translateVoice({
                mediaId: mediaId,
                duration: 5.0,
                success: (res) => {
                  hideLoading();
                  if (res.content) {
                    StartChat(res.content);
                  } else {
                    showToast("未识别到文字", "warning");
                  }
                },
                fail: (err) => {
                  hideLoading();
                  showToast("转译失败: " + JSON.stringify(err), "error");
                },
              });
              setRecording(false);
              setRecordMode(null);
              return;
            }
            throw blobErr;
          }
        } else if (recordMode === "browser-once" || recorderRef.current) {
          const recorder = recorderRef.current;
          await recorder.stopRecording();
          blob = await recorder.getBlob();
        }
        recorderRef.current = null;
        setRecording(false);
        setRecordMode(null);
        if (!blob) {
          showToast("未能获取录音数据", "warning");
          return;
        }
        if (window.useFullAudio2Text) {
          const hideLoading = showLoading("正在识别中...");
          try {
            const file = new File([blob], "recording.webm", {
              type: "audio/webm",
              lastModified: Date.now(),
            });
            const zntId = initObj?.id;
            const res = await runGetAudio2Text(zntId, file);
            const text = res?.data?.text;
            hideLoading();
            if (text) {
              StartChat(text);
            } else {
              showToast("未识别到文字", "warning");
            }
          } catch (err) {
            hideLoading();
            console.error("audio2text 调用失败", err);
            showToast("语音识别失败，请稍后重试", "error");
          }
        } else {
          await sendBlobToWebSocket(blob);
        }
      } catch (e) {
        console.error("结束录音或识别失败", e);
        showToast("结束录音失败: " + (e.message || "未知错误"), "error");
        setRecording(false);
        setRecordMode(null);
      }
    }
  };

  const startRecording = async () => {
    const ws = ensureWS();
    const startWithStream = async () => {
      let stream = await navigator.mediaDevices.getUserMedia({
        audio: true,
        video: false,
      });
      const recorder = new RecordRTC.RecordRTCPromisesHandler(stream, {
        type: "audio",
        mimeType: "audio/webm",
        recorderType: RecordRTC.StereoAudioRecorder,
        timeSlice: 400,
        desiredSampRate: 16000,
        numberOfAudioChannels: 1,
        disableLogs: false,
        ondataavailable: async (blob) => {
          if (window.isAly) {
            const aliyunBlob = await convertBlobToPCM(blob);
            console.log("转换后Blob大小:", aliyunBlob, aliyunBlob.size, "字节");
            ws.send(aliyunBlob);
          } else {
            console.log("aaa");
            ws.send(blob);
          }
        },
      });
      await recorder.startRecording();
      recorderRef.current = recorder;
      audioRef.current = ws;
      setRecording(true);
    };

    if (ws.readyState === WebSocket.OPEN) {
      await startWithStream();
    } else {
      ws.onopen = async () => {
        console.log("音频 WebSocket 链接成功");
        await startWithStream();
      };
    }
  };

  //获取分类
  const getTypes = () => {
    return axios.get(API.categary);
  };

  //获取某分类下的数据
  const getZntData = (type) => {
    return axios.get(API.categaryList + (type === "0" ? "" : parseInt(type)));
  };

  //获取分类及每个分类下的数据
  useEffect(() => {
    getTypes()
      .then((res) => {
        const categories = res?.data?.result?.data || [];
        //并行请求每个分类下的智能体数据
        const requests = categories.map((cate) => getZntData(cate.id + ""));
        axios.all(requests).then(
          axios.spread((...results) => {
            const list = categories.map((cate, index) => {
              const items = results[index]?.data?.result?.data || [];
              return {
                categoryId: cate.id,
                categoryName: cate.name,
                items: items.map((item) => ({
                  id: item.id,
                  name: item.name,
                  description: item.summary,
                  icon: item.icon,
                  outerznt: item.outerznt,
                  outerurl: item.outerurl,
                })),
              };
            });
            console.log(list, "返回的智能体广场数据");
            setCategoryDataList(list);
          }),
        );
      })
      .catch((err) => {
        console.error("获取分类数据失败", err);
      });
  }, []);

  return newInit ? (
    <div className="zdHome">
      <div className="content">
        <div className={`header ${isMob ? "m-header" : ""}`}>
          <div className="logo">
            <img src={Logo} alt=" " />
          </div>
          <div className="loginInfo">
            <div
              className="login"
              style={{
                cursor: "pointer",
              }}
              onClick={() => {
                if (!initObj?.userId && initObj?.forcelogin === 1) {
                  if (process.env.NODE_ENV === "development") {
                    return;
                  }
                  window.location.href = initObj?.loginUrl;
                } else {
                  Modal.confirm({
                    title: "",
                    content: "是否需要退出登录？",
                    okText: "确定",
                    cancelText: "取消",
                    onOk() {
                      window.location.href = window.logoutUrl;
                    },
                  });
                }
                // loginFun();
              }}
            >
              {initObj?.userName ?? initObj?.userId ?? "登录"}
            </div>
            <div className="line">
              <div
                style={{
                  width: "1px",
                  height: "16px",
                  background: "#fff",
                }}
              ></div>
            </div>
            <div
              className="setImg"
              style={{
                cursor: "pointer",
              }}
              onClick={() => {
                if (!initObj?.userId && initObj?.forcelogin === 1) {
                  if (process.env.NODE_ENV === "development") {
                    return;
                  }
                  window.location.href = initObj?.loginUrl;
                } else {
                  window.open(`/#/zdChat`, "_self");
                }
              }}
            >
              {isMob ? "" : "体验更多"}
              <img src={EnterImg} alt=" " />
            </div>
            <div
              className="setImg"
              style={{
                cursor: "pointer",
              }}
              onClick={() => {
                window.open("https://my.zju.edu.cn");
              }}
            >
              {isMob ? "" : "我的浙大"}
              <img src={BackOld} alt=" " />
              <></>
            </div>
          </div>
        </div>
        <div className="wrapContent" ref={scrollContainerRef}>
          <ChatBox
            key={"key" + newRefresh}
            className="zdHomeContent"
            placeholder={zdPlaceholder}
            welcome={{
              title: "",
              description: (
                <div
                  style={{
                    position: "relative",
                  }}
                >
                  <span
                    style={{
                      color: "#fff",
                      fontSize: "26px",
                      fontWeight: "bold",
                    }}
                  >
                    浙大人的AI服务平台
                  </span>
                  <span
                    style={{
                      color: "#fff",
                      position: "absolute",
                      top: 10,
                      background: "#4A7CBF",
                      fontSize: "12px",
                      padding: "2px 5px",
                      marginLeft: "10px",
                      borderRadius: "10px",
                    }}
                  >
                    内测
                  </span>
                </div>
              ),
              icon: NewWelcomeLogo,
            }}
            header={header}
            slotsInput={newSoltInput}
            actions={[
              initObj?.llmselectenabled === 1 ? (
                initObj?.llmlist ? (
                  otherType === "zsk" ||
                  otherType === "zskAll" ||
                  otherType === "bdmx" ? (
                    <div className="dropDown" key={"moreModel"}>
                      <Dropdown
                        trigger={["click"]}
                        arrow={true}
                        menu={{
                          items: moreModel,
                          selectable: true,
                          selectedKeys: [selectedModelValue.key],
                          onClick: ({ key }) => {
                            const selected = moreModel.find(
                              (item) => item.key === key,
                            );
                            if (selected) {
                              setSelectedModelValue({
                                key,
                                label: selected?.label,
                              });
                            }
                          },
                        }}
                      >
                        <ChatActionButton key={"moreModelList"}>
                          {selectedModelValue.label ? (
                            <Tag
                              closeIcon
                              bordered={false}
                              onClose={() => {
                                setSelectedModelValue({
                                  key: "",
                                  label: "",
                                });
                              }}
                            >
                              {selectedModelValue.label}
                            </Tag>
                          ) : (
                            "请选择模型"
                          )}
                          <DownOutlined
                            style={{
                              fontSize: 12,
                              color: "rgba(0, 0, 0, 0.45)",
                              transition: "transform 0.2s",
                            }}
                          />
                        </ChatActionButton>
                      </Dropdown>
                    </div>
                  ) : null
                ) : null
              ) : null,
              window.showThinking ? (
                initObj?.thinking === false || skillsName ? (
                  <>
                    {chooseZsk ? (
                      otherType === "zsk" ||
                      otherType == "zskAll" ||
                      otherType === "bdmx" ? (
                        <ChatThinkActionButton
                          noTitle={false}
                          key={"deepthink"}
                          checkable
                          value={deepthink}
                          onChange={setDeepthink}
                        >
                          {isMobile() ? "" : "深度思考"}
                        </ChatThinkActionButton>
                      ) : null
                    ) : otherType === "zsk" ||
                      otherType == "zskAll" ||
                      otherType === "bdmx" ? (
                      selectedModelValue?.key === "" ? (
                        <ChatThinkActionButton
                          noTitle={false}
                          key={"deepthink"}
                          checkable
                          value={deepthink}
                          onChange={setDeepthink}
                        >
                          {isMobile() ? "" : "深度思考"}
                        </ChatThinkActionButton>
                      ) : null
                    ) : null}
                  </>
                ) : otherType === "bdmx" ? (
                  selectedModelValue?.key === "" ? (
                    <ChatThinkActionButton
                      noTitle={false}
                      key={"deepthink"}
                      checkable
                      value={deepthink}
                      onChange={setDeepthink}
                    >
                      {isMobile() ? "" : "深度思考"}
                    </ChatThinkActionButton>
                  ) : null
                ) : null
              ) : null,
            ]}
            defaultValue={changeContent}
            onChange={(val) => {
              if (!initObj?.userId && initObj?.forcelogin === 1) {
                if (process.env.NODE_ENV === "development") {
                  return;
                }
                window.location.href = initObj?.loginUrl;
              } else {
                setChangeContent(val);
              }
            }}
            canSend={fileList && fileList.length > 0 ? true : undefined}
            sendButtonProps={{
              onClick: (a, b, c, d) => {
                if (!changeContent) {
                  if (fileList && fileList.length > 0) {
                    if (
                      initObj?.enabledimgupload * 1 === 1 &&
                      initObj?.enabledfileupload * 1 === 1
                    ) {
                      loginFun(initObj?.fileuploadmsg || "");
                    } else if (initObj?.enabledimgupload * 1 === 1) {
                      loginFun(initObj?.imguploadmsg || "");
                    } else if (initObj?.enabledfileupload * 1 === 1) {
                      loginFun(initObj?.fileuploadmsg || "");
                    }
                  }
                }

                // console.log(a,b,c,d)
              },
            }}
            //复制文件
            onPasteFile={async (event, files) => {
              if (
                initObj?.enabledimgupload * 1 === 1 ||
                initObj?.enabledfileupload * 1 === 1
              ) {
                setFileOpen(true);
                setTimeout(() => {
                  if (
                    files &&
                    files.length > 0 &&
                    attachmentsRef.current?.upload
                  ) {
                    for (const file of files) {
                      try {
                        attachmentsRef.current.upload(file); // 异步处理
                      } catch (error) {
                        console.error("Error uploading file:", error);
                      }
                    }
                  }
                }, 5);
              } else {
                return "";
              }
            }}
            onKeyDown={(e) => {
              if (e?.key === "Enter" && fileList && fileList.length > 0) {
                if (!changeContent) {
                  if (fileList && fileList.length > 0) {
                    if (
                      initObj?.enabledimgupload * 1 === 1 &&
                      initObj?.enabledfileupload * 1 === 1
                    ) {
                      loginFun(initObj?.fileuploadmsg || "");
                    } else if (initObj?.enabledimgupload * 1 === 1) {
                      loginFun(initObj?.imguploadmsg || "");
                    } else if (initObj?.enabledfileupload * 1 === 1) {
                      loginFun(initObj?.fileuploadmsg || "");
                    }
                  }
                } else {
                  loginFun(changeContent);
                }
              }
            }}
            beforeSendActions={
              <>
                {initObj?.enabledvinput ? (
                  <>
                    {isMobile() ? (
                      <>
                        {initObj?.vinputclientmode * 1 === 1 ||
                        initObj?.vinputclientmode * 1 === 3 ? (
                          <div
                            style={{
                              cursor: "pointer",
                              // marginRight: "12px",
                              display: "flex",
                              alignItems: "center",
                            }}
                            onClick={() => {
                              if (
                                !initObj?.userId &&
                                initObj?.forcelogin === 1
                              ) {
                                if (process.env.NODE_ENV === "development") {
                                  return;
                                }
                                window.location.href = initObj?.loginUrl;
                              } else {
                                if (recording) {
                                  stopAudio();
                                  setRecording(false);
                                } else {
                                  startAudio();
                                }
                              }
                            }}
                          >
                            <img
                              style={{
                                width: "18px",
                                height: "18px",
                              }}
                              src={recording ? AudioLoadingIcon : AudioIcon}
                              alt={recording ? "结束录音" : "开始录音"}
                            />
                          </div>
                        ) : undefined}
                      </>
                    ) : (
                      <>
                        {initObj?.vinputclientmode * 1 === 1 ||
                        initObj?.vinputclientmode * 1 === 2 ? (
                          <div
                            style={{
                              cursor: "pointer",
                              marginRight: "12px",
                              display: "flex",
                              alignItems: "center",
                            }}
                            onClick={() => {
                              if (
                                !initObj?.userId &&
                                initObj?.forcelogin === 1
                              ) {
                                if (process.env.NODE_ENV === "development") {
                                  return;
                                }
                                window.location.href = initObj?.loginUrl;
                              } else {
                                if (recording) {
                                  stopAudio();
                                  setRecording(false);
                                } else {
                                  startAudio();
                                }
                              }
                            }}
                          >
                            <img
                              style={{
                                width: "18px",
                                height: "18px",
                              }}
                              src={recording ? AudioLoadingIcon : AudioIcon}
                              alt={recording ? "结束录音" : "开始录音"}
                            />
                          </div>
                        ) : undefined}
                      </>
                    )}
                  </>
                ) : null}

                {initObj?.enabledimgupload * 1 === 1 &&
                initObj?.enabledfileupload * 1 === 1 ? (
                  <>
                    <Tooltip
                      title={
                        <div>
                          {`请上传图片或者文件（最多上传${initObj?.imguploadcount}张图片，每张图片大小30M以内，支持JPG, JPEG, PNG格式，最多上传${initObj?.fileuploadcount}个文件，每个文件大小100MB以内，支持TXT、PDF、 XLSX、 XLS、 DOCX、 CSV、 MD格式）`}
                        </div>
                      }
                    >
                      <span
                        onClick={() => {
                          if (!initObj?.userId && initObj?.forcelogin === 1) {
                            if (process.env.NODE_ENV === "development") {
                              return;
                            }
                            window.location.href = initObj?.loginUrl;
                          } else {
                            fileAndImgRef?.current?.click();
                          }
                        }}
                      >
                        <img
                          style={{
                            width: "24px",
                            height: "24px",
                            cursor: "pointer",
                          }}
                          src={window.zdDisabledFj ? DisFj : Fj}
                          alt=" "
                        />
                        {window.zdDisabledFj ? (
                          ""
                        ) : (
                          <input
                            type="file"
                            style={{
                              display: "none",
                            }}
                            ref={fileAndImgRef}
                            onClick={() => {
                              setTimeout(() => {
                                setFileOpen(true);
                              }, 3);
                            }}
                            onChange={(a) => {
                              if (window.zdDisabledFj) {
                              } else {
                                setTimeout(() => {
                                  if (
                                    a.target.files &&
                                    a.target.files.length > 0 &&
                                    attachmentsRef.current?.upload
                                  ) {
                                    for (const file of a.target.files) {
                                      try {
                                        attachmentsRef.current.upload(file); // 异步处理
                                      } catch (error) {
                                        console.error(
                                          "Error uploading file:",
                                          error,
                                        );
                                      }
                                    }
                                  } else {
                                  }
                                }, 5);
                              }
                            }}
                          />
                        )}
                      </span>
                    </Tooltip>
                  </>
                ) : (
                  <>
                    {initObj?.enabledimgupload * 1 === 1 ? (
                      <Tooltip
                        title={`${
                          initObj?.enabledimgupload * 1 === 1 &&
                          initObj?.enabledfileupload * 1 === 1
                            ? "请上传图片或者文件"
                            : initObj?.enabledimgupload * 1 === 1
                            ? `请上传图片（最多上传${initObj?.imguploadcount}张图片，每张图片大小30M以内，支持JPG, JPEG, PNG格式`
                            : ""
                        }`}
                      >
                        {" "}
                        <span
                          onClick={() => {
                            if (!initObj?.userId && initObj?.forcelogin === 1) {
                              if (process.env.NODE_ENV === "development") {
                                return;
                              }
                              window.location.href = initObj?.loginUrl;
                            } else {
                              picRef?.current?.click();
                            }
                          }}
                        >
                          <img
                            style={{
                              width: "24px",
                              height: "24px",
                              cursor: "pointer",
                            }}
                            src={Fj}
                            alt=" "
                          />
                          <input
                            type="file"
                            style={{
                              display: "none",
                            }}
                            ref={picRef}
                            onChange={(a) => {
                              setFileOpen(true);
                              setTimeout(() => {
                                if (
                                  a.target.files &&
                                  a.target.files.length > 0 &&
                                  attachmentsRef.current?.upload
                                ) {
                                  for (const file of a.target.files) {
                                    try {
                                      attachmentsRef.current.upload(file); // 异步处理
                                    } catch (error) {
                                      console.error(
                                        "Error uploading file:",
                                        error,
                                      );
                                    }
                                  }
                                }
                              }, 5);
                            }}
                          />
                        </span>{" "}
                      </Tooltip>
                    ) : undefined}

                    {initObj?.enabledfileupload * 1 === 1 ? (
                      <Tooltip
                        title={
                          <div>{`${
                            initObj?.enabledimgupload * 1 === 1 &&
                            initObj?.enabledfileupload * 1 === 1
                              ? "请上传图片或者文件"
                              : initObj?.enabledfileupload * 1 === 1
                              ? `请上传文件，最多上传${initObj?.fileuploadcount}个文件，每个文件大小100MB以内，支持TXT、PDF、XLSX、XLS、DOCX、CSV、MD格式`
                              : ""
                          }`}</div>
                        }
                      >
                        <span
                          onClick={() => {
                            if (!initObj?.userId && initObj?.forcelogin === 1) {
                              if (process.env.NODE_ENV === "development") {
                                return;
                              }
                              window.location.href = initObj?.loginUrl;
                            } else {
                              fileRef?.current?.click();
                            }
                          }}
                        >
                          <img
                            style={{
                              width: "24px",
                              height: "24px",
                              cursor: "pointer",
                            }}
                            src={Fj}
                            alt=" "
                          />
                          <input
                            type="file"
                            style={{
                              display: "none",
                            }}
                            ref={fileRef}
                            onChange={(a) => {
                              setFileOpen(true);
                              setTimeout(() => {
                                if (
                                  a.target.files &&
                                  a.target.files.length > 0 &&
                                  attachmentsRef.current?.upload
                                ) {
                                  for (const file of a.target.files) {
                                    try {
                                      attachmentsRef.current.upload(file); // 异步处理
                                    } catch (error) {
                                      console.error(
                                        "Error uploading file:",
                                        error,
                                      );
                                    }
                                  }
                                }
                              }, 5);
                            }}
                          />
                        </span>
                      </Tooltip>
                    ) : undefined}
                  </>
                )}
              </>
            }
            minRows={3}
            onSubmit={(val) => {
              loginFun(val);
            }}
            prefix={
              skillsName ? (
                <>
                  <Button
                    icon={
                      <CloseOutlined
                        onClick={() => {
                          setSkillName("");
                          setChooseZsk(false);
                          setNewSoltInput(undefined);
                          setNewRefresh(Math.random());
                          setNewInputId("");
                          setZdPlaceholder(
                            "晓浙，提供学校资讯、规范性文件、通知公告、办事指南和通讯录的精确检索与智能问答（Shift+Enter换行）",
                          );
                          setQzzkType("");
                          setOtherType("");
                        }}
                        style={{
                          fontSize: "12px",
                          color: "",
                        }}
                      />
                    }
                    iconPosition="end"
                    type="text"
                    style={{
                      color: "#1677ff",
                      background: "#0066ff0f",
                    }}
                    size="large"
                  >
                    {skillsName}
                  </Button>
                </>
              ) : (
                ""
              )
            }
            renderAfterSenderBox={() => {
              const skills = window.zdSkills[0];
              const skillsItems =
                window.zdSkills && window.zdSkills.length
                  ? // ? [skillList[0], ...window.zdSkills, ...skillList.slice(1)]
                    // [...window.zdSkills, ...skillList]
                    [
                      window.zdSkills[0],
                      ...skillList,
                      ...window.zdSkills.slice(1),
                    ]
                  : skillList || [];
              return (
                <div
                  style={{
                    width: "100%",
                  }}
                >
                  <div
                    className="jn"
                    style={{
                      padding: "20px 0",
                      width: "100%",
                    }}
                  >
                    <ChatBoxItem>
                      <ChatScrollWrapper key={"len" + skillsItems.length}>
                        {skillsItems.map((item) => {
                          return (
                            <Tooltip
                              title={
                                item?.type === "zsk"
                                  ? "关键字搜索"
                                  : item?.type === "zskAll"
                                  ? "全文总结"
                                  : ""
                              }
                            >
                              <ChatActionButton
                                style={{
                                  padding: "20px 30px",
                                }}
                                key={item?.id}
                                onClick={() => {
                                  if (
                                    !initObj?.userId &&
                                    initObj?.forcelogin === 1
                                  ) {
                                    if (
                                      process.env.NODE_ENV === "development"
                                    ) {
                                      return;
                                    }
                                    window.location.href = initObj?.loginUrl;
                                  } else {
                                    if (
                                      item.type === "zsk" ||
                                      item.type === "zskAll"
                                    ) {
                                      setZdKnowledgeOpen(true);
                                      setChooseZsk(true);
                                      setQzzkType("zsk");
                                    } else {
                                      setChooseZsk(false);
                                      setZdKnowledgeOpen(false);
                                      setSelectedValue({ key: "" });
                                    }

                                    if (item.type === "zskAll") {
                                      setQzzkType("zskFile");
                                    }
                                    if (item.type === "zsk") {
                                      setQzzkType("zsk");
                                    }

                                    if (item.type === "bdmx") {
                                      setZdPlaceholder(
                                        "基于本地大模型的智能问答（Shift+Enter换行）",
                                      );
                                    } else {
                                      setZdPlaceholder("");
                                    }
                                    setOtherType(item.type);
                                    if (item.slots && item.slots.length) {
                                      let obj = {
                                        slots: [],
                                      };
                                      if (item.id.includes("mcp")) {
                                        item.slots?.map((param) => {
                                          obj.slots.push({
                                            name: param?.field,
                                            label: param?.fieldName,
                                            required: param?.required,
                                            defaultValue: param?.defaultValue,
                                            // placeholder: param?.example,
                                            placeholder: "",
                                            type: param?.enumValues
                                              ? "select"
                                              : param?.type,
                                            options: (
                                              param?.enumValues || []
                                            ).map((jtem) => {
                                              return {
                                                label: jtem,
                                                value: jtem,
                                              };
                                            }),
                                            block: true,
                                            query: param?.query,
                                          });
                                        });
                                      }
                                      if (item.id === "mcp_17_translate") {
                                        // item.slots?.map((param) => {
                                        //   obj.slots.push({
                                        //     name: param?.field,
                                        //     label: param?.fieldName,
                                        //     required: param?.required,
                                        //     defaultValue: param?.value,
                                        //     placeholder: param?.example,
                                        //     type:
                                        //       param.field === "target_language"
                                        //         ? "select"
                                        //         : param?.type === "string"
                                        //         ? "input"
                                        //         : param?.type,
                                        //     options: (
                                        //       param?.enumValues || []
                                        //     ).map((jtem) => {
                                        //       return {
                                        //         label: jtem,
                                        //         value: jtem,
                                        //       };
                                        //     }),
                                        //     query: param?.query,
                                        //   });
                                        // });
                                      } else if (item.id === "mcp_17_ocr") {
                                        obj.slots.push({});
                                      } else {
                                        // item.slots?.map((param) => {
                                        //   obj.slots.push({
                                        //     name: param?.field,
                                        //     label: param?.fieldName,
                                        //     required: param?.required,
                                        //     defaultValue: param?.value,
                                        //     placeholder: param?.example,
                                        //     type:
                                        //       param?.type === "string"
                                        //         ? "input"
                                        //         : param?.type,
                                        //     options: param?.options,
                                        //     query: param?.query,
                                        //   });
                                        // });
                                      }

                                      if (item.id === "mcp_17_ocr") {
                                        setNewSoltInput(undefined);
                                      } else {
                                        setNewSoltInput({ ...obj });
                                      }
                                      setNewRefresh(Math.random());
                                    } else {
                                      setNewSoltInput(undefined);
                                      setNewRefresh(Math.random());
                                    }
                                    if (item.type === "zdzx") {
                                      setZdzxJump(true);
                                    } else {
                                      setZdzxJump(false);
                                    }
                                    if (item.type !== "zsk") {
                                      setNewInputId(item.id);
                                    }
                                    setSkillName(item.name);
                                  }
                                  // setZdPlaceholder("");
                                }}
                              >
                                {item?.name}
                              </ChatActionButton>
                            </Tooltip>
                          );
                        })}
                      </ChatScrollWrapper>
                    </ChatBoxItem>
                  </div>
                  <div className="jx">
                    <ChatBoxItem>
                      <ChatBubblePromptsCard
                        size="small"
                        title={
                          <>
                            <span
                              style={{
                                fontSize: isMob ? "15px" : "22px",
                                color: "#AD0000",
                                fontStyle: "italic",
                              }}
                            >
                              热点
                            </span>
                            <span
                              style={{
                                display: "inline-block",
                                width: "3px",
                                height: "3px",
                                borderRadius: "3px",
                                background: "#333",
                              }}
                            ></span>
                            <span
                              style={{
                                fontSize: isMob ? "15px" : "22px",
                                color: "#333",
                                fontStyle: "italic",
                              }}
                            >
                              资讯
                            </span>
                            <span
                              className={`aibb ${isMob ? "m-aibb" : ""} `}
                              onClick={() => {
                                console.log(audioRef);
                                togglePlayPause();
                                // axios.get(
                                //   "https://service.zju.edu.cn/_upload/aijb/aijb.mp3"
                                // );
                              }}
                            >
                              <img
                                style={{
                                  width: "23px",
                                }}
                                src={isPlaying ? DisPlayIcon : PlayIcon}
                              />
                              <span
                                style={{
                                  paddingLeft: "10px",
                                }}
                              >
                                AI播报
                              </span>
                              <audio
                                ref={audioRef}
                                src={window.audioLink || ""}
                              />
                            </span>
                          </>
                        }
                        column={2}
                        //@ts-ignore
                        shape="round"
                        arrowType="swapright"
                        type="primary"
                        extra={
                          <>
                            {hotListRef.current?.length > 8 ? (
                              <Button
                                onClick={onReloadHots}
                                style={{ color: "inherit" }}
                                type="text"
                                icon={<ReloadOutlined />}
                              >
                                换一换
                              </Button>
                            ) : null}
                          </>
                        }
                        onItemClick={(info) => {
                          console.log(info);
                          window.open(info.data?.url);
                          // StartChat(info.data.title?.toString())
                        }}
                        items={promptsItems?.slice(0, 8)}
                      />
                    </ChatBoxItem>
                  </div>
                  <div
                    style={{
                      padding: "10px 0",
                      height: "700px",
                    }}
                    className="cards"
                  >
                    <ChatBoxItem>
                      <div
                        className={isMob ? "m-scrollWrapper" : "scrollWrapper"}
                        style={{
                          overflow: isMob ? "unset" : "hidden",
                        }}
                      >
                        {/* 外层list绑定hover事件 */}
                        <div className="list">
                          {/* divder：hover时padding消失 */}
                          <div
                            className="divder"
                            style={{
                              paddingTop:
                                fixedHeight || bigScreen ? "unset" : "87px",
                            }}
                          ></div>

                          {/* listContent：hover时flexWrap改为wrap */}
                          <div
                            className="listContent"
                            style={{
                              color: "#fff",
                              display: "flex",
                              flexDirection: "row",

                              flexWrap: isMob
                                ? "wrap"
                                : fixedHeight || bigScreen
                                ? "wrap"
                                : "nowrap",

                              transform: "transform 0.3s ease",
                            }}
                          >
                            {/* 所有listItem：hover时回正，否则按滚动/小屏逻辑 */}
                            {categoryDataList.map((item) => {
                              return (
                                <div
                                  className={`listItem ${
                                    isMob ? "m-listItem" : ""
                                  } `}
                                  style={{
                                    transform: isMob
                                      ? "unset"
                                      : `rotate(${
                                          fixedHeight ? 0 : getRotateAngle()
                                        }deg)`,
                                    transition: isMob
                                      ? "unset"
                                      : "transform 0.3s ease",
                                  }}
                                >
                                  <div className="listItemContent">
                                    <div className="name">
                                      <span>{item.categoryName}</span>
                                      <span
                                        onClick={() => {
                                          window.open(
                                            `/?active=brain&show=1&categoryId=${item.categoryId}#/zdChat`,
                                            "_self",
                                          );
                                        }}
                                      >
                                        {"了解更多>>"}
                                      </span>
                                    </div>
                                    <div className="yygc">
                                      <Row>
                                        {(item.items && item.items.length
                                          ? item.items.length > 4
                                            ? item.items.slice(0, 4)
                                            : item.items
                                          : []
                                        ).map((jtem, jIndex) => {
                                          return (
                                            <Col span={12}>
                                              <div
                                                style={{
                                                  padding:
                                                    jIndex < 2
                                                      ? "20px 10px 20px 10px"
                                                      : "0 10px 10px 10px",
                                                }}
                                                onClick={() => {
                                                  if (jtem.outerznt) {
                                                    window.open(
                                                      jtem.outerurl,
                                                      "_blank",
                                                    );
                                                  } else {
                                                    window.open(
                                                      `/?znwdId=${jtem.id}#/zdChat`,
                                                      "_self",
                                                    );
                                                  }
                                                }}
                                              >
                                                <div className="xyfwListItem">
                                                  <div className="imgItem">
                                                    <img
                                                      style={{
                                                        width: "60px",
                                                        height: "60px",
                                                        borderRadius: "60px",
                                                      }}
                                                      src={jtem.icon}
                                                    />
                                                  </div>
                                                  <div className="contentItem">
                                                    <div
                                                      style={{
                                                        paddingBottom: "5px",
                                                        fontWeight: "bold",
                                                        textOverflow:
                                                          "ellipsis",
                                                        whiteSpace: "nowrap",
                                                        overflow: "hidden",
                                                      }}
                                                    >
                                                      <Tooltip
                                                        title={jtem.name}
                                                      >
                                                        {jtem.name}
                                                      </Tooltip>
                                                    </div>
                                                    <div>
                                                      <Typography.Paragraph
                                                        ellipsis={{ rows: 2 }}
                                                        style={{
                                                          color: "#666",
                                                          fontSize: 10,
                                                          opacity: 0.6,
                                                          fontWeight: 400,
                                                          fontFamily:
                                                            "思源黑体 CN",
                                                        }}
                                                      >
                                                        {jtem.description}
                                                      </Typography.Paragraph>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </Col>
                                          );
                                        })}
                                      </Row>
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                            {/* <div
                              className={`listItem ${
                                isMob ? "m-listItem" : ""
                              } `}
                              style={{
                                transform: isMob
                                  ? "unset"
                                  : `rotate(${
                                      fixedHeight ? 0 : getRotateAngle()
                                    }deg)`,
                                transition: isMob
                                  ? "unset"
                                  : "transform 0.3s ease",
                              }}
                            >
                              <div className="listItemContent">
                                <div className="name">
                                  <span>教育教学</span>
                                  <span
                                    onClick={() => {
                                      window.open(
                                        "./?active=brain&show=1#/zdChat",
                                        "_self",
                                      );
                                    }}
                                  >
                                    {"了解更多>>"}
                                  </span>
                                </div>
                                <div className="yygc">
                                  <Row>
                                    <Col span={12}>
                                      <div
                                        style={{
                                          padding: "20px 10px 20px 10px",
                                        }}
                                        onClick={() => {
                                          window.open(
                                            "https://course.zju.edu.cn/",
                                          );
                                        }}
                                      >
                                        <div className="xyfwListItem">
                                          <div className="imgItem  xzzd"></div>
                                          <div className="contentItem">
                                            <div
                                              style={{
                                                paddingBottom: "5px",
                                                fontWeight: "bold",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                              }}
                                            >
                                              <Tooltip title={"学在浙大"}>
                                                学在浙大
                                              </Tooltip>
                                            </div>
                                            <div>
                                              <Typography.Paragraph
                                                ellipsis={{ rows: 2 }}
                                                style={{
                                                  color: "#666",
                                                  fontSize: 10,
                                                  opacity: 0.6,
                                                  fontWeight: 400,
                                                  fontFamily: "思源黑体 CN",
                                                }}
                                              >
                                                贯穿课前、课中、课后的全过程沉浸式交互教学管理平台
                                              </Typography.Paragraph>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </Col>
                                    <Col span={12}>
                                      <div
                                        style={{
                                          padding: "20px 10px 20px 10px",
                                        }}
                                        onClick={() => {
                                          window.open(
                                            "https://classroom.zju.edu.cn/",
                                          );
                                        }}
                                      >
                                        <div className="xyfwListItem">
                                          <div className="imgItem zykt"> </div>
                                          <div className="contentItem">
                                            <div
                                              style={{
                                                paddingBottom: "5px",
                                                fontWeight: "bold",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                              }}
                                            >
                                              <Tooltip title={"智云课堂"}>
                                                智云课堂
                                              </Tooltip>
                                            </div>
                                            <div>
                                              <Typography.Paragraph
                                                ellipsis={{ rows: 2 }}
                                                style={{
                                                  color: "#666",
                                                  fontSize: 10,
                                                  opacity: 0.6,
                                                  fontWeight: 400,
                                                  fontFamily: "思源黑体 CN",
                                                }}
                                              >
                                                线上线下混合式同步课堂
                                              </Typography.Paragraph>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </Col>
                                    <Col span={12}>
                                      <div
                                        style={{
                                          padding: "0 10px 10px 10px",
                                        }}
                                        onClick={() => {
                                          window.open(
                                            "https://ai-assistant-h5.zju.edu.cn/portal/",
                                          );
                                        }}
                                      >
                                        <div className="xyfwListItem">
                                          <div className="imgItem aizj"></div>
                                          <div className="contentItem">
                                            <div
                                              style={{
                                                paddingBottom: "5px",
                                                fontWeight: "bold",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                              }}
                                            >
                                              <Tooltip title={"课程AI助教"}>
                                                课程AI助教
                                              </Tooltip>
                                            </div>
                                            <div>
                                              <Typography.Paragraph
                                                ellipsis={{ rows: 2 }}
                                                style={{
                                                  color: "#666",
                                                  fontSize: 10,
                                                  opacity: 0.6,
                                                  fontWeight: 400,
                                                  fontFamily: "思源黑体 CN",
                                                }}
                                              >
                                                浙江大学本科课程AI助教平台
                                              </Typography.Paragraph>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </Col>
                                    <Col span={12}>
                                      <div
                                        style={{
                                          padding: "0 10px 10px 10px",
                                        }}
                                        onClick={() => {
                                          window.open(
                                            "https://elang.zju.edu.cn/",
                                          );
                                        }}
                                      >
                                        <div className="xyfwListItem">
                                          <div className="imgItem hxwy"></div>
                                          <div className="contentItem">
                                            <div
                                              style={{
                                                paddingBottom: "5px",
                                                fontWeight: "bold",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                              }}
                                            >
                                              <Tooltip title={"慧学外语"}>
                                                慧学外语
                                              </Tooltip>
                                            </div>
                                            <div>
                                              <Typography.Paragraph
                                                ellipsis={{ rows: 2 }}
                                                style={{
                                                  color: "#666",
                                                  fontSize: 10,
                                                  opacity: 0.6,
                                                  fontWeight: 400,
                                                  fontFamily: "思源黑体 CN",
                                                }}
                                              >
                                                GenAI驱动、对标CSE量表并结合认知诊断的个性化英语自主学习平台
                                              </Typography.Paragraph>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </Col>
                                  </Row>
                                </div>
                              </div>
                            </div>
                            <div
                              className={`listItem ${
                                isMob ? "m-listItem" : ""
                              } `}
                              style={{
                                transform: isMob
                                  ? "unset"
                                  : `rotate(${
                                      fixedHeight ? 0 : getRotateAngle()
                                    }deg)`,
                                transition: isMob
                                  ? "unset"
                                  : "transform 0.3s ease",
                              }}
                            >
                              <div className="listItemContent">
                                <div className="name">
                                  <span>科研服务</span>
                                  <span
                                    onClick={() => {
                                      window.open(
                                        "./?active=brain&show=1#/zdChat",
                                        "_self",
                                      );
                                    }}
                                  >
                                    {"了解更多>>"}
                                  </span>
                                </div>
                                <div className="yygc">
                                  <Row>
                                    <Col span={12}>
                                      <div
                                        style={{
                                          padding: "20px 10px 20px 10px",
                                        }}
                                        onClick={() => {
                                          window.open(
                                            "https://research.zju.edu.cn/",
                                          );
                                        }}
                                      >
                                        <div className="xyfwListItem">
                                          <div className="imgItem yzzd"></div>
                                          <div className="contentItem">
                                            <div
                                              style={{
                                                paddingBottom: "5px",
                                                fontWeight: "bold",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                              }}
                                            >
                                              <Tooltip title={"研在浙大"}>
                                                研在浙大
                                              </Tooltip>
                                            </div>
                                            <div>
                                              <Typography.Paragraph
                                                ellipsis={{ rows: 2 }}
                                                style={{
                                                  color: "#666",
                                                  fontSize: 10,
                                                  opacity: 0.6,
                                                  fontWeight: 400,
                                                  fontFamily: "思源黑体 CN",
                                                }}
                                              >
                                                提供丰富科研工具的一站式科研门户
                                              </Typography.Paragraph>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </Col>
                                    <Col span={12}>
                                      <div
                                        style={{
                                          padding: "20px 10px 20px 10px",
                                        }}
                                        onClick={() => {
                                          window.open(
                                            "https://hpc.zju.edu.cn/",
                                          );
                                        }}
                                      >
                                        <div className="xyfwListItem">
                                          <div className="imgItem qzslzx">
                                            {" "}
                                          </div>
                                          <div className="contentItem">
                                            <div
                                              style={{
                                                paddingBottom: "5px",
                                                fontWeight: "bold",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                              }}
                                            >
                                              <Tooltip title={"启真算力中心"}>
                                                启真算力中心
                                              </Tooltip>
                                            </div>
                                            <div>
                                              <Typography.Paragraph
                                                ellipsis={{ rows: 2 }}
                                                style={{
                                                  color: "#666",
                                                  fontSize: 10,
                                                  opacity: 0.6,
                                                  fontWeight: 400,
                                                  fontFamily: "思源黑体 CN",
                                                }}
                                              >
                                                为学校提供高速共享科学计算能力的校级算力中心
                                              </Typography.Paragraph>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </Col>
                                    <Col span={12}>
                                      <div
                                        style={{
                                          padding: "0 10px 10px 10px",
                                        }}
                                        onClick={() => {
                                          window.open(
                                            "https://cryoboat.zju.edu.cn/index/cryoboat",
                                          );
                                        }}
                                      >
                                        <div className="xyfwListItem">
                                          <div className="imgItem dwzz"></div>
                                          <div className="contentItem">
                                            <div
                                              style={{
                                                paddingBottom: "5px",
                                                fontWeight: "bold",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                              }}
                                            >
                                              <Tooltip title={"低温之舟"}>
                                                低温之舟
                                              </Tooltip>
                                            </div>
                                            <div>
                                              <Typography.Paragraph
                                                ellipsis={{ rows: 2 }}
                                                style={{
                                                  color: "#666",
                                                  fontSize: 10,
                                                  opacity: 0.6,
                                                  fontWeight: 400,
                                                  fontFamily: "思源黑体 CN",
                                                }}
                                              >
                                                专为制冷低温领域打造的科研级AI助手
                                              </Typography.Paragraph>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </Col>
                                    <Col span={12}>
                                      <div
                                        style={{
                                          padding: "0 10px 10px 10px",
                                        }}
                                        onClick={() => {
                                          window.open(
                                            "https://aiearth.zju.edu.cn/",
                                          );
                                        }}
                                      >
                                        <div className="xyfwListItem">
                                          <div className="imgItem fxwx"></div>
                                          <div className="contentItem">
                                            <div
                                              style={{
                                                paddingBottom: "5px",
                                                fontWeight: "bold",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                              }}
                                            >
                                              <Tooltip
                                                title={"伏羲万象时空计算大模型"}
                                              >
                                                伏羲万象...
                                              </Tooltip>
                                            </div>
                                            <div>
                                              <Typography.Paragraph
                                                ellipsis={{ rows: 2 }}
                                                style={{
                                                  color: "#666",
                                                  fontSize: 10,
                                                  opacity: 0.6,
                                                  fontWeight: 400,
                                                  fontFamily: "思源黑体 CN",
                                                }}
                                              >
                                                基于“伏羲万象时空计算大模型”的地学AI助手
                                              </Typography.Paragraph>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </Col>
                                  </Row>
                                </div>
                              </div>
                            </div>
                            <div
                              className={`listItem ${
                                isMob ? "m-listItem" : ""
                              } `}
                              style={{
                                transform: isMob
                                  ? "unset"
                                  : `rotate(${
                                      fixedHeight ? 0 : getRotateAngle()
                                    }deg)`,
                                transition: isMob
                                  ? "unset"
                                  : "transform 0.3s ease",
                              }}
                            >
                              <div className="listItemContent">
                                <div className="name">
                                  <span>校园服务</span>
                                  <span
                                    onClick={() => {
                                      window.open(
                                        "./?active=brain&show=1#/zdChat",
                                        "_self",
                                      );
                                    }}
                                  >
                                    {"了解更多>>"}
                                  </span>
                                </div>
                                <div className="yygc">
                                  <Row>
                                    <Col span={12}>
                                      <div
                                        style={{
                                          padding: "20px 10px 20px 10px",
                                        }}
                                        onClick={() => {
                                          window.open(
                                            "https://ai-assistant-h5.zju.edu.cn/zhexiaoben-pc",
                                          );
                                        }}
                                      >
                                        <div className="xyfwListItem">
                                          <div className="imgItem zxb"></div>
                                          <div className="contentItem">
                                            <div
                                              style={{
                                                paddingBottom: "5px",
                                                fontWeight: "bold",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                              }}
                                            >
                                              <Tooltip title={"浙小本"}>
                                                浙小本
                                              </Tooltip>
                                            </div>
                                            <div>
                                              <Typography.Paragraph
                                                ellipsis={{ rows: 2 }}
                                                style={{
                                                  color: "#666",
                                                  fontSize: 10,
                                                  opacity: 0.6,
                                                  fontWeight: 400,
                                                  fontFamily: "思源黑体 CN",
                                                }}
                                              >
                                                本科智能教务助手
                                              </Typography.Paragraph>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </Col>
                                    <Col span={12}>
                                      <div
                                        style={{
                                          padding: "20px 10px 20px 10px",
                                        }}
                                        onClick={() => {
                                          window.open(
                                            "https://chat.career.zju.edu.cn/chat/pages/home",
                                          );
                                        }}
                                      >
                                        <div className="xyfwListItem">
                                          <div className="imgItem syds"> </div>
                                          <div className="contentItem">
                                            <div
                                              style={{
                                                paddingBottom: "5px",
                                                fontWeight: "bold",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                              }}
                                            >
                                              <Tooltip
                                                title={"学生生涯导师·小叶"}
                                              >
                                                学生生涯导师·小叶
                                              </Tooltip>
                                            </div>
                                            <div>
                                              <Typography.Paragraph
                                                ellipsis={{ rows: 2 }}
                                                style={{
                                                  color: "#666",
                                                  fontSize: 10,
                                                  opacity: 0.6,
                                                  fontWeight: 400,
                                                  fontFamily: "思源黑体 CN",
                                                }}
                                              >
                                                浙大学生就业专属智能体，用“一职陪你”的理念为学生提供全周期的就业服务
                                              </Typography.Paragraph>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </Col>
                                    <Col span={12}>
                                      <div
                                        style={{
                                          padding: "0 10px 10px 10px",
                                        }}
                                        onClick={() => {
                                          window.open(
                                            "./?znwdId=19#/zdChat",
                                            "_self",
                                          );
                                        }}
                                      >
                                        <div className="xyfwListItem">
                                          <div className="imgItem zwxgj"></div>
                                          <div className="contentItem">
                                            <div
                                              style={{
                                                paddingBottom: "5px",
                                                fontWeight: "bold",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                              }}
                                            >
                                              <Tooltip title={"总务小管家"}>
                                                总务小管家
                                              </Tooltip>
                                            </div>
                                            <div>
                                              <Typography.Paragraph
                                                ellipsis={{ rows: 2 }}
                                                style={{
                                                  color: "#666",
                                                  fontSize: 10,
                                                  opacity: 0.6,
                                                  fontWeight: 400,
                                                  fontFamily: "思源黑体 CN",
                                                }}
                                              >
                                                可提供全面的办事服务指南的校园总务小管家。
                                              </Typography.Paragraph>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </Col>
                                    <Col span={12}>
                                      <div
                                        style={{
                                          padding: "0 10px 10px 10px",
                                        }}
                                        onClick={() => {
                                          window.open(
                                            "./?znwdId=56#/zdChat",
                                            "_self",
                                          );
                                        }}
                                      >
                                        <div className="xyfwListItem">
                                          <div className="imgItem yxy"></div>
                                          <div className="contentItem">
                                            <div
                                              style={{
                                                paddingBottom: "5px",
                                                fontWeight: "bold",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                              }}
                                            >
                                              <Tooltip title={"医小研"}>
                                                医小研
                                              </Tooltip>
                                            </div>
                                            <div>
                                              <Typography.Paragraph
                                                ellipsis={{ rows: 2 }}
                                                style={{
                                                  color: "#666",
                                                  fontSize: 10,
                                                  opacity: 0.6,
                                                  fontWeight: 400,
                                                  fontFamily: "思源黑体 CN",
                                                }}
                                              >
                                                为医学院全日制研究生提供教育教学相关政策和办事流程的专属智能助手
                                              </Typography.Paragraph>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </Col>
                                  </Row>
                                </div>
                              </div>
                            </div>
                            <div
                              className={`listItem ${
                                isMob ? "m-listItem" : ""
                              } `}
                              style={{
                                transform: isMob
                                  ? "unset"
                                  : `rotate(${
                                      fixedHeight ? 0 : getRotateAngle()
                                    }deg)`,
                                transition: isMob
                                  ? "unset"
                                  : "transform 0.3s ease",
                              }}
                            >
                              <div className="listItemContent">
                                <div className="name">
                                  <span>实用工具</span>
                                  <span
                                    onClick={() => {
                                      window.open(
                                        "./?active=brain&show=1#/zdChat",
                                        "_self",
                                      );
                                    }}
                                  >
                                    {"了解更多>>"}
                                  </span>
                                </div>
                                <div className="yygc">
                                  <Row>
                                    <Col span={12}>
                                      <div
                                        style={{
                                          padding: "20px 10px 20px 10px",
                                        }}
                                        onClick={() => {
                                          window.open(
                                            "https://yjapi.cmc.zju.edu.cn/casapi/index.php?r=auth/login&forward=https%3A%2F%2Fconsole.cmc.zju.edu.cn%2Fyumi-aiimagelib%2Fhome%3Fsystem%3Dcmc",
                                          );
                                        }}
                                      >
                                        <div className="xyfwListItem">
                                          <div className="imgItem xysgj"></div>
                                          <div className="contentItem">
                                            <div
                                              style={{
                                                paddingBottom: "5px",
                                                fontWeight: "bold",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                              }}
                                            >
                                              <Tooltip title={"校园时光机"}>
                                                校园时光机
                                              </Tooltip>
                                            </div>
                                            <div>
                                              <Typography.Paragraph
                                                ellipsis={{ rows: 2 }}
                                                style={{
                                                  color: "#666",
                                                  fontSize: 10,
                                                  opacity: 0.6,
                                                  fontWeight: 400,
                                                  fontFamily: "思源黑体 CN",
                                                }}
                                              >
                                                以趣味互动方式沉浸式重温浙大历史与文化的AIGC工具
                                              </Typography.Paragraph>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </Col>
                                    <Col span={12}>
                                      <div
                                        style={{
                                          padding: "20px 10px 20px 10px",
                                        }}
                                        onClick={() => {
                                          window.open(
                                            "https://365.kdocs.cn/3rd/lingxi/",
                                          );
                                        }}
                                      >
                                        <div className="xyfwListItem">
                                          <div className="imgItem wpslx"> </div>
                                          <div className="contentItem">
                                            <div
                                              style={{
                                                paddingBottom: "5px",
                                                fontWeight: "bold",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                              }}
                                            >
                                              <Tooltip title={"WPS灵犀"}>
                                                WPS灵犀
                                              </Tooltip>
                                            </div>
                                            <div>
                                              <Typography.Paragraph
                                                ellipsis={{ rows: 2 }}
                                                style={{
                                                  color: "#666",
                                                  fontSize: 10,
                                                  opacity: 0.6,
                                                  fontWeight: 400,
                                                  fontFamily: "思源黑体 CN",
                                                }}
                                              >
                                                深度融合在WPS
                                                Office中的智能办公助手
                                              </Typography.Paragraph>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </Col>
                                    <Col span={12}>
                                      <div
                                        style={{
                                          padding: "0 10px 10px 10px",
                                        }}
                                        onClick={() => {
                                          window.open(
                                            "https://form.zju.edu.cn/",
                                          );
                                        }}
                                      >
                                        <div className="xyfwListItem">
                                          <div className="imgItem tbzs"></div>
                                          <div className="contentItem">
                                            <div
                                              style={{
                                                paddingBottom: "5px",
                                                fontWeight: "bold",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                              }}
                                            >
                                              <Tooltip title={"填表助手"}>
                                                填表助手
                                              </Tooltip>
                                            </div>
                                            <div>
                                              <Typography.Paragraph
                                                ellipsis={{ rows: 2 }}
                                                style={{
                                                  color: "#666",
                                                  fontSize: 10,
                                                  opacity: 0.6,
                                                  fontWeight: 400,
                                                  fontFamily: "思源黑体 CN",
                                                }}
                                              >
                                                校园智能填表工具
                                              </Typography.Paragraph>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </Col>
                                  </Row>
                                </div>
                              </div>
                            </div> */}
                          </div>
                        </div>
                      </div>
                    </ChatBoxItem>
                  </div>
                </div>
              );
            }}
          />
        </div>
      </div>
      <div className="copyRight">
        版权所有&nbsp;&nbsp;&copy;&nbsp;&nbsp;浙江大学&nbsp;&nbsp;浙ICP备05074421号-1&nbsp;&nbsp;浙公网安备33010602010295
      </div>

      {recording &&
        isMobile() &&
        window.isFullTime &&
        window.isMobileAudio &&
        createPortal(
          <>
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                backgroundColor: "rgba(0, 0, 0, 0.45)",
                zIndex: 9998,
              }}
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
              }}
            />
            <div
              style={{
                position: "fixed",
                bottom: 0,
                left: 0,
                width: "100%",
                height: "240px",
                backgroundColor: "#fff",
                zIndex: 9999,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "flex-start",
                borderTopLeftRadius: "16px",
                borderTopRightRadius: "16px",
                boxShadow: "0 -4px 12px rgba(0,0,0,0.1)",
                padding: "24px 20px 40px",
                transition: "all 0.3s ease-in-out",
              }}
            >
              <div
                style={{
                  fontSize: "16px",
                  fontWeight: "500",
                  color: "#333",
                  marginBottom: "40px",
                }}
              >
                正在录音...
              </div>
              <div
                style={{
                  display: "flex",
                  gap: "6px",
                  height: "40px",
                  alignItems: "center",
                  flexShrink: 0,
                }}
              >
                {[1, 2, 3, 4, 5, 6, 7].map((i) => (
                  <div
                    key={i}
                    style={{
                      width: "4px",
                      height: "10px",
                      background: "#1890ff",
                      borderRadius: "2px",
                      animation: "wave 1.2s infinite ease-in-out",
                      animationDelay: `${i * 0.1}s`,
                    }}
                  />
                ))}
                <style>{`
                          @keyframes wave {
                            0%, 100% { height: 10px; opacity: 0.5; }
                            50% { height: 32px; opacity: 1; }
                          }
                        `}</style>
              </div>

              <div
                style={{
                  display: "flex",
                  width: "100%",
                  justifyContent: "space-around",
                  alignItems: "center",
                  marginTop: "auto",
                }}
              >
                <div
                  onClick={cancelRecording}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                >
                  <div
                    style={{
                      width: "72px",
                      height: "72px",
                      borderRadius: "50%",
                      background: "#f5f5f5",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                      marginBottom: "8px",
                      border: "1px solid #eee",
                    }}
                  >
                    <CloseOutlined
                      style={{ fontSize: "32px", color: "#666" }}
                    />
                  </div>
                  <span style={{ fontSize: "16px", color: "#666" }}>取消</span>
                </div>
                <div
                  onClick={stopAudio}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                >
                  <div
                    style={{
                      width: "72px",
                      height: "72px",
                      borderRadius: "50%",
                      background: "#1890ff",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      boxShadow: "0 4px 12px rgba(24,144,255,0.4)",
                      marginBottom: "8px",
                    }}
                  >
                    <CheckOutlined
                      style={{ fontSize: "32px", color: "#fff" }}
                    />
                  </div>
                  <span style={{ fontSize: "16px", color: "#333" }}>发送</span>
                </div>
              </div>
            </div>
          </>,
          document.body,
        )}

      {zdKnowledgeOpen ? (
        <>
          <Drawer
            title="知识库"
            open={zdKnowledgeOpen}
            destroyOnHidden
            width={isMob ? "100%" : "65%"}
            onClose={() => {
              setZdKnowledgeOpen(false);
              setZdKnowledgeName("");
              setSkillName("");
              setChooseZsk(false);
              setNewInputId("");
              setOtherType("");
              setZdPlaceholder(
                "晓浙，提供学校资讯、规范性文件、通知公告、办事指南和通讯录的精确检索与智能问答（Shift+Enter换行）",
              );
            }}
            footer={
              <>
                <Space>
                  <Button
                    onClick={() => {
                      setZdKnowledgeOpen(false);
                      setZdKnowledgeName("");
                      setChooseZsk(false);
                      setSkillName("");
                      setNewInputId("");
                      setOtherType("");
                      setZdPlaceholder(
                        "晓浙，提供学校资讯、规范性文件、通知公告、办事指南和通讯录的精确检索与智能问答（Shift+Enter换行）",
                      );
                    }}
                  >
                    关闭
                  </Button>
                  <Button
                    type="primary"
                    onClick={() => {
                      console.log(zdKnowledgeRef);
                      const data = zdKnowledgeRef?.current?.getValue();
                      setSelectedValue({
                        key:
                          qzzkType === "zskFile"
                            ? "qw_" +
                              data?.zskId?.split("/")[
                                data?.zskId?.split("/").length - 1
                              ]
                            : data?.zskId,
                        name: data?.zskName,
                      });
                      setZdKnowledgeName(data?.zskName);
                      setZdKnowledgeOpen(false);
                      setSkillName(data?.zskName);
                      setNewInputId("");
                      setZdPlaceholder("");
                    }}
                  >
                    确定
                  </Button>
                </Space>
              </>
            }
          >
            <ZdKnowledge ref={zdKnowledgeRef} type={qzzkType} />
          </Drawer>
        </>
      ) : null}
    </div>
  ) : null;
}

export default ZdHome;
